import { render, staticRenderFns } from "./ProjectSettingsForm.vue?vue&type=template&id=db892c82&scoped=true&"
import script from "./ProjectSettingsForm.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db892c82",
  null
  
)

export default component.exports